import React from "react";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Chip,
  Stack,
  Tooltip,
  IconButton,
  Button, TextField, CircularProgress, Modal
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import dayjs from "dayjs"; // Make sure you have dayjs installed
import baseURL from "../../../config";

const SignOnModal = ({ signonDetails }) => {
  if (!signonDetails || signonDetails.length === 0) return null;
  const [formData, setFormData] = useState({
    portName: "",
    portCountry: "",
    date: "",
    cdcStamppageFile: "",
    passport: "",
    salaryclose: "",
  });

  const [selectedContract, setSelectedContract] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedCrewName, setSelectedCrewName] = useState("");
  const [open, setOpen] = useState(false);
  const userID = localStorage.getItem("user id");
  const [loading, setLoading] = useState(false);

  // console.log("userID", userID)

  const handleOpen = (contract, crewName) => {
    setSelectedContract(contract);
    setSelectedCrewName(crewName);
    setOpen(true);
    setFormData({
      portName: "",
      portCountry: "",
      date: "",
    });

    // console.log(contract)
    // console.log(crewName)

  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      portName: "",
      portCountry: "",
      date: "",
      cdcStamppageFile: "",
      passport: "",
      salaryclose: "",
    });
  };

  const handleSave = async () => {
    const { portName, portCountry, date, cdcStamppageFile, passport, salaryclose } = formData;

    if (!portName || !portCountry || !date || !cdcStamppageFile || !passport || !salaryclose) {
      toast.error("All fields are required.");
      return;
    }

    if (!selectedContract) {
      toast.error("No contract selected!");
      return;
    }



    setLoading(true);

    const token = localStorage.getItem("token");

    const dataToSend = new FormData();

    // Append basic text data
    dataToSend.append("creatorId", userID);
    dataToSend.append("crewId", selectedContract.contractDetails?.crewDetails?._id || "");
    dataToSend.append("contractId", selectedContract.contractDetails?._id || "");

    // console.log("creatorId", userID)
    // console.log("crewId", selectedContract.contractDetails?.crewDetails?._id)
    // console.log("contractId", selectedContract.contractDetails?._id)

    // Prepare signOff metadata only (without files)
    const signOffData = [
      {
        date: formData.date,
        portName: formData.portName,
        portCountry: formData.portCountry,
      }
    ];
    dataToSend.append("signOff", JSON.stringify(signOffData));

    // Append files with nested keys
    if (formData.cdcStamppageFile?.file) {
      dataToSend.append("signOff[0][cdcStamppageFile]", formData.cdcStamppageFile.file);
    }

    if (formData.passport?.file) {
      dataToSend.append("signOff[0][passport]", formData.passport.file);
    }

    if (formData.salaryclose?.file) {
      dataToSend.append("signOff[0][salaryclose]", formData.salaryclose.file);
    }

    try {
      const response = await axios.post(`${baseURL}/api/statusAfterForm1`, dataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Data saved successfully!");
      handleClose();

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error saving data:", error.response?.data || error.message);
      toast.error("Failed to save data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        [name]: {
          file,
          originalName: file.name,
        },
      }));
    }
  };


  return (
    <>
      <Box p={3}>
        <Typography variant="h6" gutterBottom>
          Sign-On Records
        </Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Contract Details</TableCell>
                <TableCell>Documents</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {signonDetails.map((item, index) => {
                const contract = item.contractDetails;
                const signOn = item.contractStatusAfterForm1?.signOn?.[0] || {};
                const signOnDate = signOn?.date;
                const formattedSignOn = signOnDate ? dayjs(signOnDate).format("DD-MM-YYYY") : "N/A";
                const coc = item.contractStatusAfterForm1?.coc?.[0] || {};
                const cocDate = coc?.date || coc?.Date;
                const formattedcoc = cocDate ? dayjs(cocDate).format("DD-MM-YYYY") : "N/A";

                const contractDuration = signOn?.contractDuration;

                const vesselName = contract?.ShipDetails?.vesselname || contract?.vesselName || "N/A";
                const crewName = contract?.crewdetails?.name || contract?.crewName || "N/A";
                const indosNo = contract?.crewdetails?.indosno || "N/A";
                const rankName = contract?.rank?.rankname || contract?.rankName || "N/A";

                return (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>

                    <TableCell>
                      <Stack
                        direction="row"
                        spacing={1.5}               // Increased spacing between chips
                        flexWrap="wrap"
                        useFlexGap                 // Enables `gap` behavior for wrapping too
                        rowGap={1.5}               // Adds vertical space between wrapped rows
                      >
                        <Chip label={`Crew: ${crewName}`} size="small" color="info" />
                        <Chip label={`Indos No.: ${indosNo}`} size="small" color="warning" />
                        <Chip label={`Rank: ${rankName}`} size="small" color="success" />
                        {formattedcoc && (
                          <Chip label={`COC Date: ${formattedcoc}`} size="small" color="warning" />
                        )}
                        {signOnDate && (
                          <Chip label={`SignOn Date: ${formattedSignOn}`} size="small" color="primary" />
                        )}
                        {contractDuration && (
                          <Chip
                            icon={<HourglassBottomIcon />}
                            label={`Contract: ${contractDuration}`}
                            size="small"
                            sx={{ bgcolor: "#e3f2fd", color: "#1976d2" }}
                          />
                        )}
                        {signOn.text && (
                          <Chip
                            label={`Note: ${signOn.text}`}
                            size="small"
                            sx={{ bgcolor: "#ffcdd2" }}
                          />
                        )}
                      </Stack>
                    </TableCell>


                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        {signOn.ImoCrewListFile?.originalName ? (
                          <Tooltip title={signOn.ImoCrewListFile.originalName}>
                            <IconButton
                              color="primary"
                              onClick={() =>
                                window.open(
                                  `${baseURL}/${signOn.ImoCrewListFile.filePath.replace(/\\/g, "/")}`,
                                  "_blank"
                                )
                              }
                            >
                              <PictureAsPdfIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Chip label="No IMO File" size="small" variant="outlined" />
                        )}

                        {signOn.cdcStamppageFile?.originalName ? (
                          <Tooltip title={signOn.cdcStamppageFile.originalName}>
                            <IconButton
                              color="primary"
                              onClick={() =>
                                window.open(
                                  `${baseURL}/${signOn.cdcStamppageFile.filePath.replace(/\\/g, "/")}`,
                                  "_blank"
                                )
                              }
                            >
                              <PictureAsPdfIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Chip label="No cdcStamppageFile" size="small" variant="outlined" />
                        )}

                      </Stack>
                    </TableCell>

                    <TableCell>
                      <IconButton variant="contained" color="primary" onClick={() => handleOpen(item, contract?.crewdetails?.name || "N/A")}>
                        <EditIcon />
                      </IconButton>

                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Modal to Enter Sign-On Details */}
      <Modal open={open} onClose={handleClose}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            p: 3,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Enter Sign-Off: {" "}
            {selectedCrewName && (
              <span style={{ color: "green" }}> {selectedCrewName}</span>
            )}
          </Typography>
          <TextField
            fullWidth
            required
            label="Port Name"
            name="portName"
            value={formData.portName}
            onChange={handleChange}
            margin="dense"

          />
          <TextField
            fullWidth
            required
            label="Port Country"
            name="portCountry"
            value={formData.portCountry}
            onChange={handleChange}
            margin="dense"

          />
          <TextField
            fullWidth
            required
            label="Date"
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            margin="dense"
            inputProps={{
              max: new Date().toISOString().split("T")[0],
            }}

          />

          {/* File Upload: cdc Stamp page File Page */}
          <Box mt={2} display="flex" justifyContent="space-between">
            <Typography variant="body2" gutterBottom>
              CDC
            </Typography>
            <label htmlFor="cdc-upload">
              <input
                accept="application/pdf,image/*"
                style={{ display: "none" }}
                id="cdc-upload"
                type="file"
                name="cdcStamppageFile"
                onChange={handleFileChange}
              />
              <Button
                variant="outlined"
                component="span"
                fullWidth
              >
                {formData.cdcStamppageFile?.originalName || "Upload File"}
              </Button>
            </label>
          </Box>

          <Box mt={2} display="flex" justifyContent="space-between">
            <Typography variant="body2" gutterBottom>
              Passport
            </Typography>
            <label htmlFor="passport-upload">
              <input
                accept="application/pdf,image/*"
                style={{ display: "none" }}
                id="passport-upload"
                type="file"
                name="passport"
                onChange={handleFileChange}
              />
              <Button
                variant="outlined"
                component="span"
                fullWidth
              >
                {formData.passport?.originalName || "Upload File"}
              </Button>
            </label>
          </Box>

          <Box mt={2} display="flex" justifyContent="space-between">
            <Typography variant="body2" gutterBottom>
              salary closure
            </Typography>
            <label htmlFor="salaryclose-upload">
              <input
                accept="application/pdf,image/*"
                style={{ display: "none" }}
                id="salaryclose-upload"
                type="file"
                name="salaryclose"
                onChange={handleFileChange}
              />
              <Button
                variant="outlined"
                component="span"
                fullWidth
              >
                {formData.salaryclose?.originalName || "Upload File"}
              </Button>
            </label>
          </Box>

          <Box mt={2} display="flex" justifyContent="space-between">
            <Button onClick={handleClose} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              color="primary"
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} color="inherit" />}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
          </Box>
        </Paper>
      </Modal>
    </>
  );
};

export default SignOnModal;
